import { Component, Input } from '@angular/core';
import { InterestRateLogData } from '../account.model';

@Component({
	selector: 'ifb-account-interest-rate-change-history',
	templateUrl: './account-interest-rate-change-history.component.html',
	styleUrls: ['./account-interest-rate-change-history.component.scss'],
	standalone: false
})
export class AccountInterestRateChangeHistoryComponent {
	@Input()
	entries: InterestRateLogData[];
}
